var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"list"},_vm._l((_vm.links),function(link,index){return _c('li',{key:`breadcrumbLink-${index}`,staticClass:"item"},[_c('FlatActionAnchor',{class:[
        'breadcrumb',
        { 'active': index === _vm.currentStep }
      ],attrs:{"href":link.href,"target":"_self"},on:{"click":function($event){return _vm.handleClick(index)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }